import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';

export const MapCalendarRequest = (
  requestDetails: AppointmentRequestDetails,
  requestDate: { dateStart: string; dateEnd: string } | undefined) => ({
    id: requestDetails.id,
    startDate: requestDate?.dateStart ? new Date(requestDate.dateStart) : undefined,
    endDate: requestDate?.dateEnd ? new Date(requestDate.dateEnd) : undefined,
  })